module.exports = __webpack_public_path__ + "img/price-4550.24a6f74f.png";